import RestProperty from './types/RestProperty';

import AssignmentExpression from './types/AssignmentExpression';
import AssignmentPattern from './types/AssignmentPattern';
import ArrayExpression from './types/ArrayExpression';
import ArrayPattern from './types/ArrayPattern';
import ArrowFunctionExpression from './types/ArrowFunctionExpression';
import AwaitExpression from './types/AwaitExpression';
import BinaryExpression from './types/BinaryExpression';
import BindExpression from './types/BindExpression';
import BlockStatement from './types/BlockStatement';
import BooleanLiteral from './types/BooleanLiteral';
import BreakStatement from './types/BreakStatement';
import CallExpression from './types/CallExpression';
import CatchClause from './types/CatchClause';
import ClassBody from './types/ClassBody';
import ClassDeclaration from './types/ClassDeclaration';
import ClassExpression from './types/ClassExpression';
import ClassMethod from './types/ClassMethod';
import ClassProperty from './types/ClassProperty';
import ConditionalExpression from './types/ConditionalExpression';
import ContinueStatement from './types/ContinueStatement';
import DebuggerStatement from './types/DebuggerStatement';
import Directive from './types/Directive';
import DirectiveLiteral from './types/DirectiveLiteral';
import DoWhileStatement from './types/DoWhileStatement';
import EmptyStatement from './types/EmptyStatement';
import ExportAllDeclaration from './types/ExportAllDeclaration';
import ExportDefaultDeclaration from './types/ExportDefaultDeclaration';
import ExportDefaultSpecifier from './types/ExportDefaultSpecifier';
import ExportNamedDeclaration from './types/ExportNamedDeclaration';
import ExportNamespaceSpecifier from './types/ExportNamespaceSpecifier';
import ExportSpecifier from './types/ExportSpecifier';
import ExpressionStatement from './types/ExpressionStatement';
import ForInStatement from './types/ForInStatement';
import ForOfStatement from './types/ForOfStatement';
import ForStatement from './types/ForStatement';
import FunctionDeclaration from './types/FunctionDeclaration';
import FunctionExpression from './types/FunctionExpression';
import Identifier from './types/Identifier';
import IfStatement from './types/IfStatement';
import ImportDeclaration from './types/ImportDeclaration';
import ImportDefaultSpecifier from './types/ImportDefaultSpecifier';
import ImportNamespaceSpecifier from './types/ImportNamespaceSpecifier';
import ImportSpecifier from './types/ImportSpecifier';
import JSXAttribute from './types/JSXAttribute';
import JSXClosingElement from './types/JSXClosingElement';
import JSXElement from './types/JSXElement';
import JSXEmptyExpression from './types/JSXEmptyExpression';
import JSXExpressionContainer from './types/JSXExpressionContainer';
import JSXIdentifier from './types/JSXIdentifier';
import JSXMemberExpression from './types/JSXMemberExpression';
import JSXNamespacedName from './types/JSXNamespacedName';
import JSXOpeningElement from './types/JSXOpeningElement';
import JSXSpreadAttribute from './types/JSXSpreadAttribute';
import JSXText from './types/JSXText';
import LabeledStatement from './types/LabeledStatement';
import LogicalExpression from './types/LogicalExpression';
import MemberExpression from './types/MemberExpression';
import MetaProperty from './types/MetaProperty';
import NewExpression from './types/NewExpression';
import NullLiteral from './types/NullLiteral';
import NumericLiteral from './types/NumericLiteral';
import ObjectExpression from './types/ObjectExpression';
import ObjectMethod from './types/ObjectMethod';
import ObjectPattern from './types/ObjectPattern';
import ObjectProperty from './types/ObjectProperty';
import Program from './types/Program';
import RegExpLiteral from './types/RegExpLiteral';
import RestElement from './types/RestElement';
import ReturnStatement from './types/ReturnStatement';
import SequenceExpression from './types/SequenceExpression';
import SpreadElement from './types/SpreadElement';
import SpreadProperty from './types/SpreadProperty';
import StringLiteral from './types/StringLiteral';
import Super from './types/Super';
import SwitchCase from './types/SwitchCase';
import SwitchStatement from './types/SwitchStatement';
import TaggedTemplateExpression from './types/TaggedTemplateExpression';
import TemplateElement from './types/TemplateElement';
import TemplateLiteral from './types/TemplateLiteral';
import ThisExpression from './types/ThisExpression';
import ThrowStatement from './types/ThrowStatement';
import TryStatement from './types/TryStatement';
import UnaryExpression from './types/UnaryExpression';
import UpdateExpression from './types/UpdateExpression';
import VariableDeclaration from './types/VariableDeclaration';
import VariableDeclarator from './types/VariableDeclarator';
import WithStatement from './types/WithStatement';
import WhileStatement from './types/WhileStatement';
import YieldExpression from './types/YieldExpression';

export default {
    RestProperty,

    AssignmentExpression,
    AssignmentPattern,
    ArrayExpression,
    ArrayPattern,
    ArrowFunctionExpression,
    AwaitExpression,
    BinaryExpression,
    BindExpression,
    BlockStatement,
    BooleanLiteral,
    BreakStatement,
    CallExpression,
    CatchClause,
    ClassBody,
    ClassDeclaration,
    ClassExpression,
    ClassMethod,
    ClassProperty,
    ConditionalExpression,
    ContinueStatement,
    DebuggerStatement,
    Directive,
    DirectiveLiteral,
    DoWhileStatement,
    EmptyStatement,
    ExportAllDeclaration,
    ExportDefaultDeclaration,
    ExportDefaultSpecifier,
    ExportNamedDeclaration,
    ExportNamespaceSpecifier,
    ExportSpecifier,
    ExpressionStatement,
    ForInStatement,
    ForOfStatement,
    ForStatement,
    FunctionDeclaration,
    FunctionExpression,
    Identifier,
    IfStatement,
    ImportDeclaration,
    ImportDefaultSpecifier,
    ImportNamespaceSpecifier,
    ImportSpecifier,
    JSXAttribute,
    JSXClosingElement,
    JSXElement,
    JSXEmptyExpression,
    JSXExpressionContainer,
    JSXIdentifier,
    JSXMemberExpression,
    JSXNamespacedName,
    JSXOpeningElement,
    JSXSpreadAttribute,
    JSXText,
    LabeledStatement,
    LogicalExpression,
    MemberExpression,
    MetaProperty,
    NewExpression,
    NullLiteral,
    NumericLiteral,
    ObjectExpression,
    ObjectMethod,
    ObjectPattern,
    ObjectProperty,
    Program,
    RegExpLiteral,
    RestElement,
    ReturnStatement,
    SequenceExpression,
    SpreadElement,
    SpreadProperty,
    StringLiteral,
    Super,
    SwitchCase,
    SwitchStatement,
    TaggedTemplateExpression,
    TemplateElement,
    TemplateLiteral,
    ThisExpression,
    ThrowStatement,
    TryStatement,
    UnaryExpression,
    UpdateExpression,
    VariableDeclaration,
    VariableDeclarator,
    WithStatement,
    WhileStatement,
    YieldExpression,
};
